import {Button, Row, Table} from "antd";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import {columnsTab} from "./config";
import {listTab as listTabInit} from "data/list";
import {ListActionButton, Notification} from "components/common";
import {authenticationService} from "api";
const ModalRoleTab = forwardRef((props: any, ref) => {
  const {dataMenu, selectedRoleId} = props;
  const [selectedRowKeys, setSelectedRowKeys] = useState<any[]>([]);
  const onRowSelect = (selectedRowKeys, selectedRows, info) => {
    setSelectedRowKeys(selectedRowKeys);
  };
  const [params, setParams] = useState({page: 1, limit: 10});
  const handlePaginationChange = (page, pageSize?: number) => {
    setParams({...params, page: page, limit: pageSize});
  };
  const paginationConfig = {
    onChange: handlePaginationChange,
  };
  const [listTab, setListTab] = useState<any>(listTabInit);
  const [dataTab, setDataTab] = useState<any>([]);
  const [idObjectCreated, setIdObjectCreated] = useState(null);
  // columnsTab.find(e => e.key == "action").render = (value, record, index) => {
  //   return <ListActionButton deleteFunction={() => {}}> </ListActionButton>;
  // };
  useImperativeHandle(ref, () => ({
    getListTabByRole: () => {
      getListTabByRole(selectedRoleId);
    },
  }));
  const getListTabByRole = async roleId => {
    try {
      const res = await authenticationService.getListTabByRoleAlina(roleId);
      if (res?.length > 0) {
        const _dataTab = JSON.parse(res?.[0]?.tab);
        setIdObjectCreated(res?.[0]?.id);
        setDataTab(_dataTab);
      } else {
        setIdObjectCreated(null);
        setDataTab([]);
      }
    } catch (error) {}
  };
  useEffect(() => {
    setSelectedRowKeys(dataTab);
  }, [dataTab]);
  useEffect(() => {
    setSelectedRowKeys([]);
    getListTabByRole(selectedRoleId);
  }, [selectedRoleId]);
  useEffect(() => {
    const setListTabByDataMenu = dataMenu => {
      const _listTab = listTabInit.filter(tab =>
        dataMenu.some(e => e?.menu == tab?.menuKey)
      );
      setListTab(_listTab);
    };
    setListTabByDataMenu(dataMenu);
  }, [dataMenu]);
  const submitTab = async () => {
    try {
      const tab = JSON.stringify(selectedRowKeys);
      let params = [{roleId: selectedRoleId, tab: tab, id: idObjectCreated}];
      const callApi =
        idObjectCreated != null
          ? authenticationService.updateTabToRoleAlina
          : authenticationService.addTabToRoleAlina;
      const res = await callApi(params);
      getListTabByRole(selectedRoleId);
      Notification("success", "Đã thêm thành công");
    } catch (error) {
      Notification("eror", "Đã xảy ra lỗi");
    }
  };
  return (
    <div>
      <Table
        columns={columnsTab}
        dataSource={listTab?.map(e => ({
          key: e?.tabKey,
          tab: e?.tab,
          menu: e?.menuKey,
        }))}
        rowSelection={{
          selectedRowKeys: selectedRowKeys,
          type: "checkbox",
          onChange: onRowSelect,
        }}
        pagination={paginationConfig}
      ></Table>
      <Row justify={"end"}>
        <Button type="primary" onClick={submitTab}>
          Lưu
        </Button>
      </Row>
    </div>
  );
});
export default ModalRoleTab;
